<script lang="ts">
	import { replaceVariables } from '../replaceVariables/replaceVariables'
	import {
		type StructuredTextGraphQlResponse,
		render as renderStructuredText,
	} from 'datocms-structured-text-to-html-string'

	interface Props {
		structuredText: StructuredTextGraphQlResponse
		variables?: Record<string, string>
	}

	let { structuredText, variables = {} }: Props = $props()
</script>

<!-- eslint-disable-next-line svelte/no-at-html-tags -->
{@html replaceVariables(renderStructuredText(structuredText), variables)}
